import React from "react";
import { Layout } from '../components/layout/Layout';
import { ForgotPasswordForm } from '../components/features/Auth/ForgotPasswordForm';
import { LoginForm } from '../components/features/Auth/LoginForm';

const LoginPageContent: React.FC = () => {
  const [state, setState] = React.useState<'login' | 'forgot'>('login')

  switch (state) {
    case 'login':
      return <LoginForm onForgot={() => setState('forgot')} />
    case 'forgot':
    return <ForgotPasswordForm onCancel={() => setState('login')} />
    default:
      return null
  }
}

const LoginPage: React.FC = () => {
  return (
    <Layout showNavOptions={true} showCurrentUserDetails={true} header={true} footer={false}>
      <LoginPageContent />
    </Layout>
  )
}

export default LoginPage;
